import { FC } from 'react';
import PromotionType from '@components/interface/Promotion';
import CreateAccount from './CreateAcount';

const Promotion: PromotionType = {
  CreateAccount,
};

export default Promotion;
